export default  {
	"appVersion": 1,  // Only increment on major changes that break compatibility with local storage data
	"bundleVersion": 203, // Gets incremented on every build
}
